import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedNewsfeed } from '@/connectors'

export const NewsfeedPage: FC = (): ReactElement => (
    <Page className="newsfeed-page">
        <ConnectedNewsfeed />
    </Page>
)
